import React, { useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import IconCloseNew from 'resources/Icon-Close-Btn.png';
import './SapphireInfoModal.css';

const SapphireInfoModal = ({ show, onClose }) => {
  const iframeRef = useRef(null);
  const [iframeHeight, setIframeHeight] = useState('auto');

  const adjustIframeHeight = () => {
    const iframe = iframeRef.current;

    if (iframe) {
      const iframeDocument =
        iframe.contentDocument || iframe.contentWindow.document;

      if (iframeDocument && iframeDocument.body) {
        const contentHeight = iframeDocument.body.scrollHeight;
        const maxHeight = window.innerHeight * 0.8;
        setIframeHeight(Math.min(contentHeight, maxHeight) + 20 + 'px');
      }
    }
  };

  return (
    <Modal className="sapphire-info-modal" show={show} onHide={onClose}>
      <Modal.Body>
        <button
          onClick={onClose}
          type="button"
          className="close-button-component"
        >
          <img src={IconCloseNew} alt="Close Modal" />
        </button>
        <iframe
          ref={iframeRef}
          src="sapphire-webview.html"
          title="Sapphire Info"
          onLoad={adjustIframeHeight}
          style={{ height: iframeHeight }}
        />
      </Modal.Body>
    </Modal>
  );
};

export default SapphireInfoModal;
